<template>
  <div class="care-list">
    <div class="header-layout" v-if="ShowCareBar">
      <img class="avatar" :src="user.avatar" />
      <div class="user-info">
        <div class="username">{{ user.name || user.phone }}</div>
        <div class="care-total-info" v-if="cares.length > 0">
          {{ cares.length + "张无忧卡" }}
        </div>
      </div>
    </div>
    <div class="h-box">
      <img src="../../assets/care_guide_1.png" />
      <img src="../../assets/care_guide_2.png" />
      <img src="../../assets/care_guide_3.png" />
      <img src="../../assets/care_guide_4.png" />
    </div>
    <div class="nav-menu" v-if="ShowCareBar">
      <span class="actived" @click="goto('/care')"><i class="nav-care-menu-ico-1"></i>我的无忧卡</span>
    </div>
  </div>
</template>

<script>
import { login } from "../../scripts/auth";
import { httpOpen } from "../../scripts/network";

export default {
  name: "MyCare",
  data() {
    return {
      user: {
        name: "",
        phone: "",
        avatar: require("../../assets/ic_default_avatar.png"),
      },
      cares: []
    };
  },
  computed: {
   ShowCareBar() {
     //return this.$store.state.ShowCareBar;
     return false;
   }
  },
  created() {
	if(this.ShowCareBar){
		this.initUserInfo();
		this.loadMyCare();
	}
  },
  methods: {
    initUserInfo() {
      const info = this.$store.state.userInfo;
      if (!info) {
        // login(this.$store, this.$router);
        return;
      }
      this.user = {
        avatar: info.avatar || require("../../assets/ic_default_avatar.png"),
        name: info.name || "",
        phone: info.phone || "",
      };
    },
    async loadMyCare() {
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/GetUserCardList", {
          type: "post",
          body: { CustomerMobilePhone: this.user.phone },
        });
        if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        } else if (!ret.Status) {
          this.$toast("加载失败，请稍后重试");
        } else {
          this.cares = ret.Data.map(this.resultMapper);
        }

        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
      resultMapper(data) {
          const supportnew = 1; // 是否支持续费
          return {
              id: data.sysNo,
              type: data.ServiceType,
              endTime: data.FailureTime && new Date(data.FailureTime + "+08:00"),
              imei: data.IMEICode,
              status: data.CardStatus,
              audit: data.AuditStatus,
              name: data.ServiceTypeName,
              single: !data.EquityVal || data.EquityVal.length <= 1,
              code : data.ActivationCode,
              effectiveDay: data.EffectiveDay,
              img: data.CardLogo,
              renewCard: data.IsSupportRenew == supportnew, // 可续费卡
              canRenew: data.IsSupportRenew == supportnew && data.CardStatus == 20, // 当前是否可以续费(卡已激活 && 可续费卡)
              surplus: data.FailureTime && new Date(data.FailureTime + "+08:00").diff(new Date()).day,// 有效天数(剩余过期天数)
          };
      }
  },
};
</script>
<style lang="less" scoped>
.care-list {
  background: #f4f4f4 url("~@/assets/care-head-bg.png") 0 0 no-repeat;
  background-size: 100%;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 50px;
  button {
    width: 100%;
    text-align: center;
    color: white;
    font-size: 16px;
    line-height: 34px;
    height: 34px;
    border: none;
    margin: 16px 0;

    background: linear-gradient(
      86deg,
      rgba(224, 172, 119, 1) 0%,
      rgba(186, 136, 89, 1) 100%
    );
    border-radius: 17px;
  }

  button:active {
    background: linear-gradient(
      86deg,
      rgb(230, 165, 101) 0%,
      rgb(212, 114, 22) 100%
    );
  }
}
h4 {
  font-size: 16px;
  margin: 0;
}

.header-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 40px 24px 16px 24px;
  .avatar {
    display: block;
    width: 58px;
    height: 58px;
    border-radius: 29px;
    box-sizing: border-box;
    border: 4px solid white;
    margin-right: 8px;
  }

  .scan_qr{
    width: 21px;
  }

  .user-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 1;
  }
  .username {
    color: black;
    font-weight: bold;
    font-size: 16px;
  }
  .care-total-info {
    font-size: 10px;
    color: #fbefd7;
    background: black;
    height: 20px;
    line-height: 20px;
    padding: 0 6px;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 4px;
  }

  .care-total-info::before {
    content: "";
    display: block;
    background: url("../../assets/ic_star.png") no-repeat top left;
    background-size: 15px 15px;
    width: 15px;
    height: 15px;
  }
}
.bottom-banner {
  width: 100%;
  height: auto;
  margin-top: 16px;
  img {
    margin-top: 8px;
    width: 100%;
    border-radius: 8px;
  }
}
.cards {
  padding: 8px 16px;
}

.card + .card {
  margin-top: 10px;
}

.h-box{
  img {
    display: block;
    width: 100%;
  }
}
.nav-menu{
  position: fixed;
  display: flex;
  bottom: 0;
  left: 0;
  right: 0;
  height: 47px;
  background-color: #fff;
  align-items: center;
  z-index: 10;
  box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.11);
  font-weight: 600;
  >span{
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60%;
    font-size: 14px;
    color: #111111;
    &:not(:first-child){
      border-left: 1px solid #cbcbcb;
    }
    .nav-care-menu-ico-1{
      display: inline-block;
      width: 30px;
      height: 22px;
      background: url("~@/assets/nav-care-menu-ico-1.png") 0 0 no-repeat;
      background-size: 100%;
      margin-right: 10px;
    }
    .nav-care-menu-ico-2{
      display: inline-block;
      width: 23px;
      height: 24px;
      background: url("~@/assets/nav-care-menu-ico-2.png") 0 0 no-repeat;
      background-size: 100%;
      margin-right: 10px;
    }
    &.actived{
      .nav-care-menu-ico-1{
        background: url("~@/assets/nav-care-menu-ico-1-actived.png") 0 0 no-repeat;
        background-size: 100%;
      }
      .nav-care-menu-ico-2{
        background: url("~@/assets/nav-care-menu-ico-2-actived.png") 0 0 no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>
